import React from 'react';
import { Box, Typography } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ForumIcon from '@mui/icons-material/Forum';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';

import AdvisorDashboardTile from './AdvisorDashboardTile';
import { useGetAppConfigQuery } from 'app/api/mainApi';

const AdvisorHelpAndSupport = () => {
  const { data: appConfig } = useGetAppConfigQuery();

  return (
    <AdvisorDashboardTile
      title="Help & Support"
      icon={<HelpOutlineIcon sx={{ color: '#888' }} />}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          my: 4,
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <a
            href="http://support.niteflirt.com/hc/en-us/categories/201835568-Help-for-Flirts"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          >
            <HelpOutlineIcon fontSize="large" sx={{ color: '#747474' }} />
            <Typography variant="body3" sx={{ mt: 0.5 }}>
              Flirt Help
            </Typography>
          </a>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <a
            href={appConfig.forumUrl}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          >
            <ForumIcon fontSize="large" sx={{ color: '#747474' }} />
            <Typography variant="body3" sx={{ mt: 0.5 }}>
              Community Forum
            </Typography>
          </a>
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <a
            href="http://support.niteflirt.com/hc/en-us/requests/new?ticket_form_id=18558"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          >
            <ContactSupportIcon fontSize="large" sx={{ color: '#747474' }} />
            <Typography variant="body3" sx={{ mt: 0.5 }}>
              Support Request
            </Typography>
          </a>
        </Box>
      </Box>
    </AdvisorDashboardTile>
  );
};

export default AdvisorHelpAndSupport;
